import { render, staticRenderFns } from "./tradetotal.vue?vue&type=template&id=14969eaa&scoped=true"
import script from "./tradetotal.vue?vue&type=script&lang=js"
export * from "./tradetotal.vue?vue&type=script&lang=js"
import style0 from "./tradetotal.vue?vue&type=style&index=0&id=14969eaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14969eaa",
  null
  
)

export default component.exports